module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('p', {
    staticClass: "lined"
  }), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  }, [_c('i', [_vm._v("To the eyes of an outsider, the initial impression of ancient Egypt is one of unfamiliarity")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—"), _c('b', [_vm._v("JAROMIR MALEK")]), _vm._v(", "), _c('i', [_vm._v("In the Shadow of the Pyramids")]), _vm._v(": "), _c('i', [_vm._v("Egypt during the Old Kingdom")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b98c1fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Frontmatter03.vue
// module id = 90
// module chunks = 0